var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreupfrount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.46118 12.2456V18.081C3.46118 21.382 3.46118 23.0325 4.48631 24.058C5.51143 25.0836 7.16135 25.0836 10.4612 25.0836H17.4612C20.761 25.0836 22.4109 25.0836 23.436 24.058C24.4612 23.0325 24.4612 21.382 24.4612 18.081V12.2456",
    stroke: "#8F9DAC",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4612 19.8252C16.6631 20.5336 15.3924 20.9919 13.9612 20.9919C12.5299 20.9919 11.2593 20.5336 10.4612 19.8252",
    stroke: "#8F9DAC",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7877 9.8218C11.4587 11.0099 10.2622 13.0594 7.98898 13.3565C5.9818 13.6187 4.45945 12.7426 4.0706 12.3762C3.64188 12.0792 2.66477 11.1287 2.42549 10.5347C2.18619 9.94062 2.46536 8.65348 2.66477 8.12871L3.46192 5.8206C3.65652 5.24086 4.11207 3.86968 4.57909 3.40589C5.04613 2.94211 5.99169 2.92193 6.38088 2.92193H14.554C16.6577 2.95165 21.2576 2.90317 22.1669 2.92194C23.0762 2.9407 23.6227 3.70293 23.7822 4.02966C25.1389 7.31595 25.6666 9.19803 25.6666 10C25.4895 10.8556 24.7566 12.4688 22.1669 13.1783C19.4754 13.9157 17.9495 12.4814 17.4709 11.9307M10.681 11.9307C11.0599 12.3961 12.2484 13.3328 13.9712 13.3565C15.6941 13.3803 17.1818 12.1783 17.7101 11.5743C17.8597 11.3961 18.1828 10.8674 18.5178 9.8218",
    stroke: "#8F9DAC",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreupfrount);
export default __webpack_public_path__ + "static/media/storeupfrount.1650cc8229ba88805c5eac02dd33e426.svg";
export { ForwardRef as ReactComponent };